// @flow
import React, { Component, Fragment } from 'react';

type Props = {
    item: {
        id: number,
        description: string,
        access_type: {
            name: string,
        },
    },
    title: string,
    cost: string,
    branding: {
        paywall_primary_color: string,
    },
    priceOption: number,
    handleClick: Function,
};

class PriceOptionItem extends Component<Props> {
    render() {
        let price = {};
        if (this.props.priceOption === this.props.item.id) {
            price.border =
                '1px solid ' + this.props.branding.paywall_primary_color;
        }

        let border = '1px solid #00aae6';
        return (
            <label className="radio-with-div">
                <input
                    onClick={() => this.props.handleClick(this.props.item)}
                    className="ipx-checkhid"
                    type="radio"
                    data-pricing-type={
                        this.props.item.access_type.name !== 'subscription'
                            ? 'package'
                            : 'subscription'
                    }
                    name="package-selected"
                />
                <div className="pricing_item" style={price}>
                    <div className="pricing_left">
                        {this.props.item.item_type === 'package' ? (
                            <i className="ipic_many-asset" />
                        ) : (
                            <i className="ipic_one-asset" />
                        )}
                        {this.props.item.access_type.name ===
                            'subscription' && <i className="ipic_recurring" />}
                    </div>
                    <div className="pricing_right">
                        <h2>
                            {this.props.item.access_type.name ===
                                'subscription' &&
                                `${this.props.title.trim()}: `}
                            <strong>{this.props.cost}</strong>
                        </h2>
                        <p>{this.props.item.description}</p>
                    </div>
                </div>
            </label>
        );
    }
}

export default PriceOptionItem;



// WEBPACK FOOTER //
// ./src/ui/components/Forms/PriceOption/PriceOptionItem.js